<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-16 20:34:46
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-20 22:38:37
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/cywl/component-cywl.vue
 * @Description: 描述
-->
<template>
  <div class="cywl" v-loading="loading.cywl">
    <vue-seamless-scroll
      :class-option="classOption"
      :data="cywl"
      v-if="!loading.cywl"
    >
      <div class="item" v-for="(item, index) in cywl" :key="index">
        <div class="cotent">
          <div class="value">{{ item.value }}</div>
          <div
            class="icon"
            :style="{ background: `url(${icons[item.name]})` }"
          ></div>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('production-management', ['loading', 'cywl']),
    classOption () {
      return {
        limitMoveNum: true,
        // 速度
        step: 1,
        // 鼠标停止
        hoverStop: true,
        // 0 下 1 上 2 左 3 右
        direction: 2,
        singleWidth: 121,
        waitTime: 1000
      }
    },
    icons () {
      return {
        无人机: '/image/production-management/icon/茶园物联/无人机@2x.png',
        气象站: '/image/production-management/icon/茶园物联/气象站@2x.png',
        水肥系统: '/image/production-management/icon/茶园物联/水肥系统@2x.png',
        LED绿色防控系统: '/image/production-management/icon/茶园物联/LED绿色防控系统@2x.png',
        风力智能防霜系统: '/image/production-management/icon/茶园物联/风力智能防霜系统@2x.png',
        乘用型采茶机: '/image/production-management/icon/茶园物联/乘用型采茶机@2x.png'
      }
    }
  },
  methods: {
    ...mapActions('production-management', ['getCYWL'])
  },
  created () {
    this.getCYWL()
  }
}
</script>

<style lang="scss">
.cywl {
  height: 99px;
  width: 363px;
  margin-top: 10px;
  overflow: hidden;
  .item {
    display: inline-block;
    vertical-align: top;
    width: 121px;
    height: 99px;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url("/public/image/production-management/bg/矩形@2x.png");
    position: relative;
    .value {
      display: block;
      text-align: center;
      font-size: 26px;
      font-family: Bahnschrift;
      font-weight: 400;
      color: #edc727;
      background: linear-gradient(0deg, #38f7ff 0%, #c5fdff 99.6337890625%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .icon {
      display: block;
      margin: 0 auto;
      width: 57px;
      height: 28px;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .name {
      display: block;
      text-align: center;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.8;
      width: calc(100% - 56px);
      margin: 0 auto;
    }
  }
}
</style>
